import { Attr, BelongsTo, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import Facility from './facility';
import WebauthnChallenge from './webauthn_challenge';
import Workstation from './workstation';

@Model()
export default class SsmSession extends ApplicationRecord {
  static jsonapiType = 'ssm_sessions';
  @Attr() sessionId: string;
  @Attr() tokenValue: string;
  @Attr() streamUrl: string;
  @Attr() createdAt: string;
  @Attr() updatedAt: string;
  @Attr() instanceId: string;
  @Attr() plaintext: string;
  @Attr() ciphertextBlob: string;
  @Attr() success: boolean;
  // NOT named `kind` in any form: Spraypaint uses `kind` as a decorator
  // sentinel (decorators.js: `obj.kind !== undefined`), so a `kind` accessor —
  // even via `@Attr({ name: 'kind' })` — crashes module load. Serializes to
  // the wire attribute `session_kind`. 'shell' (default) | 'rdp'.
  @Attr() sessionKind: string;

  @BelongsTo() workstation: Workstation;
  @BelongsTo() facility: Facility;
  @BelongsTo() webauthnChallenge: WebauthnChallenge;
}
